// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"9f4f2658","259":"4bf380cf","381":"e4accac4","508":"ec867c84","527":"db473c0f","673":"8c72687a","678":"833fd690","895":"d15b338e"}[chunkId] + ".chunk.css";
};